var bMovies 	= [];
var videoTimes 	= [];
var mainMoviePC, mainMovieSP;
videojs.hook('setup', function(player){
	var id = player.id_;
	if(id === "video-1" || id === "video-2" || id === "video-3" || id === "video-4"){
		player.muted(true);
		player.pause();
		if(id === "video-2"){
			bMovies[1] = player;
			var $video1 = $("#blk-basic03 .movie");
			var $blockID = $("#blk-basic03")
			common.checkVideoTimeupdate("blk-basic03", player, "main_movie");
			$("#blk-basic03 .movie").off().on("click", function(){
				var $thisMovie = $(this);
				if($thisMovie.hasClass("active")){
					$thisMovie.removeClass("active");
				}else{
					$thisMovie.addClass("active");
				}
			});
			$("#blk-basic03 a.thumb").off().on("click", function(){
				if(!$("#blk-basic03 .movie").hasClass("playing")){
					$("#blk-basic03 .movie").addClass("playing");
				}
				bMovies[1].play();
			});
			$("#blk-basic03 .ui-video .btn-playback").off().on("click", function(){
				var $this = $(this);
				player.currentTime(0);
				//google analytics
				let label 		= $this.attr("data-ga");
				let category 	= $this.attr("data-category");
				let action 		= "back"
				common.sendClickGa(label, category, action);
			});
			$("#blk-basic03 .ui-video .btn-toggleplay").off().on("click", function(){
				var $this = $(this);
				if(player.paused()){
					$this.removeClass("active");
					$("#blk-basic03 .movie").addClass("playing");
					player.play();
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "play";
				} else {
					$this.addClass("active");
					player.pause();
					$("#blk-basic03 .movie").removeClass("playing");
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "stop";
				}
				common.sendClickGa(label, category, action);
			});
			$("#blk-basic03 .ui-video .btn-volume").off().on("click", function(){
				var $this = $(this);
				if(player.muted()){
					$this.addClass("active");
					player.muted(false);
				} else {
					$this.removeClass("active");
					player.muted(true);
				}
			});
		}else if(id === "video-1"){
			//console.log(id, player)
			bMovies[0] = player;
			//3番目の値はGAにわたす値
			common.checkMotionTimeupDate("video-1", player, "video-basic01");
		}else if(id === "video-3"){
			//console.log(id, player)
			bMovies[2] = player;
			//3番目の値はGAにわたす値
			common.checkMotionTimeupDate("video-3", player, "video-basic03");
		}else if(id === "video-4"){
			//console.log(id, player)
			bMovies[3] = player;
			//3番目の値はGAにわたす値
			common.checkMotionTimeupDate("video-4", player, "video-basic04");
		}
	}
});
var vol5 = {
	players: [],
	timer: "",
	init: function(){
		let $body = $("body");
		var imgArry = [];
		this.resize();
		$(".video-js").each(function(i){
			var thisID = $(this).attr("id");
			videojs(thisID);
		});

		$("#wrapper img").each(function(){
			imgArry.push($(this).attr("src"));
		});
		preloadPage.startLoad(imgArry.length,imgArry, 0).done(function(){
			vol5.startContent();
		});

		$("#block-nav").on("touchmove", function(e){
			if($html.classList.contains("show-nav")){
				e.preventDefault();
			}
		});
	},
	startContent: function(){
		let $body = $("body");
		$body.removeClass("disable");
		$(".movie").addClass("active");
		setTimeout(function(){
			$("#basic #main").addClass("active");
			setTimeout(function(){
				$body.removeClass("fixed");
				$("#loading").remove();
				setTimeout(function(){
					let posY = $("#ttl-page .ttl-page-content").offset().top;
					common.scrollToPosition(posY, 600);
				},100);
			},1500);
		},400);
		$(document).on("scroll touchmove", function(){
			vol5.scrl();
		});
		vol5.nav();
	},
	nav: function(){
		let $body = $("body"),
			modalMovie = $("#video-4")[0];

		modalMovie.addEventListener('ended', function() {
			modalMovie.currentTime = 0;
		}, false);
		$("a.btn-modal").off().on("click", function(){
			let $this = $(this);
			if(!$html.classList.contains("show-movie")){
				common.sendClickGa("modal_open", "main_movie", "click");

				$html.classList.add("movie");
				setTimeout(function(){
					$html.classList.add("show-movie");
					setTimeout(function(){
						bMovies[3].play();
						$("#blk-basic02 .btns ul").addClass("hide");
						$("#video-4_html5_api").off().on("ended", function(){
							$("#video-4_html5_api")[0].currentTime = 0;
						});
						if($("#video-2").hasClass("vjs-playing")){
							bMovies[1].pause();
							$("#video-2").removeClass("vjs-playing");
						}
					},600);
				},50);
			}
		});
		$("#bg-movie").off().on("click", function(){
			closeMovie();
		});
		$("a.btn-close-movie").off().on("click", function(){
			closeMovie();
		});
		function closeMovie(){
			if($html.classList.contains("show-movie")){
				$html.classList.remove("show-movie");
				setTimeout(function(){
					$html.classList.remove("movie");
					$("#blk-basic02 .btns ul").removeClass("hide");
					bMovies[1].pause();
				},600);
			}
		}
	},
	resize: function(){
		let winW = $(window).width(),
			winH = $(window).height();
		let rx = 1366,
			ry = 644,
			minw = 1366,
			minh = 644;

		var sizes_pc	= fs(rx, ry, minw, minh, winW, winH);
		
		//var sizes_sp 	= fs(rx, ry, minw, minh, )
		sizes_pc[0] = sizes_pc[0];
		sizes_pc[1] = sizes_pc[1];
		//console.log(sizes_pc[0], sizes_pc[1]);
		if(isSmallScreen){
			$("#main #bg_main").css({
				"width": winW + "px",
				"height": winH + "px"
			})
		}else{
			$("#main #bg_main").css({
				"width": "",
				"height": ""
			})
		}
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			alen = animates.length,
			winH = $(window).height(),
			$body = $("body");
		common.checkScrolledPos(topD);
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}else{
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}
		}
		if(btmD > winH){
			if(!$body.hasClass("hide_logo")){
				$body.addClass("hide_logo");
			}
		}else{
			if($body.hasClass("hide_logo")){
				$body.removeClass("hide_logo");
			}
		}

		//Parallax
		var bg01Top = $("#blk-basic02").offset().top;
		if(btmD > bg01Top){
			if(!$body.hasClass("show_bg")){
				$body.addClass("show_bg");
			}
		}else{
			if($body.hasClass("show_bg")){
				$body.removeClass("show_bg");
			}
		}
		var bg02Top = $("#block-product").offset().top;
		if(btmD > bg02Top){
			if(!$body.hasClass("show_bg02")){
				$body.addClass("show_bg02");
			}
		}else{
			if($body.hasClass("show_bg02")){
				$body.removeClass("show_bg02");
			}
		}
		
		if(btmD >= $(document).height()-50){
			if(!$body.hasClass("btm")){
				$body.addClass("btm");
			}
		}else{
			if($body.hasClass("btm")){
				$body.removeClass("btm");
			}
		}
		//long movie
		var movie1Top = $("#blk-basic03 .movie").offset().top,
			movie1Btm = movie1Top + $("#blk-basic03 .movie").outerHeight() + winH;
		//console.log(movie2top, movie2btm)
		if(btmD < movie1Top){
			if($("#video-2").hasClass("vjs-playing")){
				bMovies[1].pause();
				$("#blk-basic03 .movie").removeClass("playing");
			}
		}else if(btmD > movie1Btm){
			if($("#video-2").hasClass("vjs-playing")){
				bMovies[1].pause();
				$("#blk-basic03 .movie").removeClass("playing");
			}
		}else{
			if($("#video-2").hasClass("vjs-paused") && !$("#video-2").hasClass("played")){
				var $blk = $("#blk-basic03");
				if(!$blk.hasClass("animate")){
					$blk.addClass("animate");
					setTimeout(function(){
						$blk.addClass("animated");
					},2000);
				}
				$("#blk-basic03 .movie").addClass("playing");
				bMovies[1].play();
				setTimeout(function(){
					$("#blk-basic03 .movie").removeClass("active");
				},2000);
				$("#video-2").addClass("playing");
				var category 	= "main_movie",
					label 	 	= "start_play",
					action 		= "play";
				common.sendClickGa(label, category, action);
				$("#video-2").addClass("played");
			}
		}

		//motion
		var video2Top = $("#video-1").offset().top;
		var video2Btm = video2Top + $("#video-1").outerHeight();
		if(btmD >= video2Top && topD < video2Btm){
			if(!$("#video-1").hasClass("vjs-playing")){
				bMovies[0].play();
				//初回の再生時だけGAをtimeupdateに頼らず送るためのplayed
				if(!$("#video-1").hasClass("played")){
					$("#video-1").addClass("played");
					let category 	= "motion01";
					let action 		= "play";
					let label 		= "start"
					common.sendClickGa(label, category, action);
				}
			}
		}else if(btmD < video2Top){
			if($("#video-1").hasClass("vjs-playing")){
				bMovies[0].pause();
			}
		}
		if(topD >= video2Btm){
			if($("#video-1").hasClass("vjs-playing")){
				bMovies[0].pause();
			}
		}
		//video-3
		var video3Top = $("#video-3").offset().top;
		var video3Btm = video3Top + $("#video-3").outerHeight();
		if(btmD >= video3Top && topD < video3Btm){
			if(!$("#video-3").hasClass("vjs-playing")){
				bMovies[2].play();
				//初回の再生時だけGAをtimeupdateに頼らず送るためのplayed
				if(!$("#video-3").hasClass("played")){
					$("#video-3").addClass("played");
					let category 	= "motion03";
					let action 		= "play";
					let label 		= "start"
					common.sendClickGa(label, category, action);
				}
			}
		}else if(btmD < video3Top){
			if($("#video-3").hasClass("vjs-playing")){
				bMovies[2].pause();
			}
		}
		if(topD >= video3Btm){
			if($("#video-3").hasClass("vjs-playing")){
				bMovies[2].pause();
			}
		}

		function activeAnimation(a){
			var $block = $(".a").eq(a);
			if(!$block.hasClass("animate")){
				$block.addClass("animate");
				if($block.attr("data-movieid") === "2"){
					setTimeout(function(){
						if($("#video-basic02 .movie").hasClass("active")){
							$("#video-basic02 .movie").removeClass("active");
						}
					},2000);
				}
				setTimeout(function(){
					$block.addClass("animated");
				},1000);
			}
		}
		//ga
		var galen = gablocks.length;
		for(var g = 0; g < galen; g++){
			if(btmD >= gablocks[g].top){
				activeGa(g)
			}
		}
		function activeGa(g){
			var $blk = $(".gablock").eq(g);
			if(!$blk.hasClass("active")){
				$blk.addClass("active");
				var label = $blk.attr("data-ga");
				common.sendScrollPageGa(label);
			}
		}
	}
}